module.exports = __webpack_public_path__ + "media/img/pro-icon-efbc104e.svg";